<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="slide-2-wrapper">
    <div class="title">{{ $t("tutorial.ways_to_find") }}</div>

    <div class="first-quote">
      <div class="image-icon"></div>
      <span class="quote-text" v-html="$t('tutorial.search_by_photo')"></span>
    </div>

    <div class="second-quote">
      <div class="T-icon"></div>
      <span class="quote-text" v-html="$t('tutorial.describe_to_ai')"></span>
    </div>

    <div class="third-quote">
      <div class="image-icon"></div>
      +
      <div class="T-icon"></div>
      <span class="quote-text" v-html="$t('tutorial.combine_photo_text')"></span>
    </div>
  </div>
</template>

<style scoped>
.slide-2-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(#a5c1e8, #908fdd);
  border-radius: 40px;
  justify-content: center;
}

.image-icon {
  height: 100%;
  background-image: url("@/assets/img/imagesForTutotrial/image-slide-2.svg");
  background-size: 100% 100%;
  z-index: 3;
  top: 60%;
  left: 5%;
  transform: rotate(5grad);
}

.T-icon {
  height: 100%;
  background-image: url("@/assets/img/imagesForTutotrial/T-cion.svg");
  background-size: 100% 100%;
  z-index: 3;
  top: 60%;
  left: 5%;
  transform: rotate(-3grad);
}

.quote-text {
  font-size: clamp(0.875rem, 0.1607rem + 1.1161vw, 1.5rem);
  color: var(--white-100);
  font-family: "Gilroy", sans-serif;
}

.green-text {
  color: #dcffac;
}

.first-quote,
.second-quote,
.third-quote {
  position: absolute;
}

.first-quote {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  top: 30%;
  left: 10%;

  padding: 10px;
  border: 1px solid var(--white-40);
  border-radius: 20px;
  transform: rotate(-6deg);
  z-index: 1;
  background: rgba(255, 255, 255, 0.2); /* Полупрозрачный фон */
  backdrop-filter: blur(10px); /* Размытие */
}

.second-quote {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  top: 46%;
  right: 6%;
  padding: 10px;
  border: 1px solid var(--white-80);
  border-radius: 20px;
  transform: rotate(6deg);
  z-index: 2;
  background: rgba(255, 255, 255, 0.2); /* Полупрозрачный фон */
  backdrop-filter: blur(10px); /* Размытие */
}

.third-quote {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0;
  top: 66%;
  left: 12%;
  padding: 10px;
  border: 2px solid #dcffac;
  border-radius: 20px;
  transform: rotate(-6deg);
  z-index: 3;
  background: rgba(255, 255, 255, 0.2); /* Полупрозрачный фон */
  backdrop-filter: blur(10px); /* Размытие */
}

.third-quote {
  font-size: 42px;
  color: var(--white-100);
}

.first-quote > .quote-text {
  width: 19ch;
}

.second-quote > .quote-text {
  width: 20ch;
}

.third-quote > .quote-text {
  width: 28ch;
}

.image-icon {
  height: 3em;
  width: 3em;
  font-size: clamp(0.875rem, 0.1607rem + 1.1161vw, 1.5rem);
}

.T-icon {
  width: 3em;
  height: 3em;
  font-size: clamp(0.875rem, 0.1607rem + 1.1161vw, 1.5rem);
}

.title {
  text-align: center;
  padding-top: 40px;
  width: 15ch;
  font-size: clamp(2.875rem, 0.4464rem + 3.7946vw, 5rem);
  color: var(--white-100);
  font-family: "Gilroy", sans-serif;
  font-weight: 600;
  position: relative;
  height: fit-content;
  z-index: 5;
}

@media (max-width: 1024px) {
  .quote-text {
    font-size: clamp(0.6875rem, 0.247rem + 1.9578vw, 1.5rem);
  }

  .title {
    font-size: clamp(2.25rem, 0.759rem + 6.6265vw, 5rem);
  }

  .third-quote {
    left: 6%;
    padding: 10px;
  }

  .second-quote {
    padding: 10px;
  }

  .first-quote {
    width: 19ch;
    padding: 10px;
  }
}
</style>
